import Vue from 'vue'
import gql from 'graphql-tag'

const query = gql`
  query people (
    $page: Int = 1
    $limit: Int = 50
    $name: String
    $nameOrDocumentNumber: String
    $id: ID
    $status: String
    $dateStart: ISO8601Date
    $dateEnd: ISO8601Date
    $campaignId: ID
    $orderBy: String = "import_files.created_at"
    $order: String = "desc",
    $periodBy: String
  ) {
    people (
      page: $page
      limit: $limit
      name: $name
      nameOrDocumentNumber: $nameOrDocumentNumber
      id: $id
      status: $status
      dateStart: $dateStart
      dateEnd: $dateEnd
      campaignId: $campaignId
      orderBy: $orderBy
      order: $order
      periodBy: $periodBy
    ) {
      collection  {
        id name status humanizedStatus
        payments {
          value
          paidAt
        }
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`

/**
* @param {*} page
* @param {*} limit
* @param {*} name
* @param {*} nameOrDocumentNumber
* @param {*} id
* @param {*} status
* @param {*} dateStart
* @param {*} dateEnd
* @param {*} campaignId
* @param {*} orderBy
* @param {*} order
**/

async function getPeople( params = {} ) {
  const { $api } = Vue.prototype
  const data = await $api.query({
    query,
    fetchPolicy: 'no-cache',
    variables: params
  }).then( res => res )
  .catch( e => e )
  return data
}

export { getPeople }
